export default __webpack_public_path__ + "static/media/UFO_VIEWER_GRAY.f5a11588.png";